import { Link } from "react-router-dom";
import { TOURNAMENT } from "@/data/tournament";
import { useTeams } from "@/hooks/useTeams";

const Teams = () => {
  const teams = useTeams();
  const slotsRemaining = Math.max(TOURNAMENT.totalTeams - teams.length, 0);

  return (
    <section
      id="equipos"
      data-testid="teams-section"
      className="relative bg-[#050505] py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-16">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-[#EAB308] mb-4">
              / 04 · Los Participantes
            </div>
            <h2 className="font-display text-5xl sm:text-6xl uppercase tracking-tight leading-none">
              Equipos
              <br />
              <span className="text-[#EAB308]">confirmados.</span>
            </h2>
          </div>
          <div className="flex items-center gap-6">
            <div>
              <div className="text-xs tracking-[0.3em] uppercase text-white/40">
                Confirmados
              </div>
              <div className="font-display text-4xl">
                {String(teams.length).padStart(2, "0")}
                <span className="text-white/30">/{TOURNAMENT.totalTeams}</span>
              </div>
            </div>
            <div className="w-px h-12 bg-white/10" />
            <div>
              <div className="text-xs tracking-[0.3em] uppercase text-white/40">
                Plazas Libres
              </div>
              <div className="font-display text-4xl text-[#EAB308]">
                {String(slotsRemaining).padStart(2, "0")}
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {/* Confirmed teams */}
          {teams.map((team, idx) => (
            <Link
              key={team.slug}
              to={`/equipos/${team.slug}`}
              data-testid={`team-card-${idx}`}
              className="relative bg-[#0a0a0a] p-6 sm:p-8 min-h-[200px] flex flex-col justify-between group hover:bg-[#0f0f0f] transition-colors overflow-hidden"
            >
              <div className="absolute top-0 right-0 text-[10px] tracking-[0.25em] uppercase text-white/20 p-3">
                #{String(idx + 1).padStart(2, "0")}
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
                <span className="text-[10px] tracking-[0.3em] uppercase text-green-400 font-medium">
                  CONFIRMADO
                </span>
              </div>

              <div>
                <div className="font-display text-2xl sm:text-3xl text-white leading-tight uppercase tracking-tight group-hover:text-[#EAB308] transition-colors">
                  {team.name}
                </div>
                <div className="mt-3 flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-white/40 group-hover:text-[#EAB308] transition-colors">
                  <div className="w-4 h-px bg-white/30" />
                  Ver página <span>→</span>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 h-px w-0 bg-green-400 group-hover:w-full transition-all duration-700" />
            </Link>
          ))}

          {/* Empty slots */}
          {Array.from({ length: Math.min(slotsRemaining, 15) }).map((_, idx) => (
            <a
              key={`slot-${idx}`}
              href="#inscripciones"
              data-testid={`team-slot-${idx}`}
              className="relative bg-[#070707] p-6 sm:p-8 min-h-[200px] flex flex-col justify-between group hover:bg-[#0a0a0a] transition-colors border border-dashed border-white/5 hover:border-[#EAB308]/40 overflow-hidden"
            >
              <div className="absolute top-0 right-0 text-[10px] tracking-[0.25em] uppercase text-white/15 p-3">
                #{String(teams.length + idx + 1).padStart(2, "0")}
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 border border-white/30 rounded-full" />
                <span className="text-[10px] tracking-[0.3em] uppercase text-white/40">
                  Plaza Libre
                </span>
              </div>
              <div>
                <div className="font-display text-2xl sm:text-3xl text-white/30 group-hover:text-[#EAB308] leading-tight uppercase tracking-tight transition-colors">
                  Tu equipo
                  <br />
                  aquí
                </div>
                <div className="mt-3 flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-white/30 group-hover:text-[#EAB308] transition-colors">
                  Inscribir
                  <span>→</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Teams;
